<template>
  <div>
    <custom-actions show-back title="审批详情">
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="160px"
        v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="inventoryType" label="类型">
              {{ inventoryTypeMap.get(formData.inventoryType) }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-if="formData.inventoryType === '1'" prop="ygId" label="油罐名称">
              {{ formData.ygId }}
            </el-form-item>
            <el-form-item v-if="formData.inventoryType === '2'" prop="ygId" label="成品油名称">
              {{ formData.goodsCodeName }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="ygLevel" label="本次变化液位">
              {{ formData.ygLevel }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ygWeight" label="本次变化重量">
              {{ formData.ygWeight }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="userId" label="客户">
              {{ formData.userName || '未知客户' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="driverName" label="司机姓名">
              {{ formData.driverName }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="driverMobile" label="司机手机号">
              {{ formData.driverMobile }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="vehicleKey" label="车牌号">
              {{ formData.vehicleKey }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="vehicleDate" label="进场日期">
              {{ formData.vehicleDate }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="vehicleTime" label="进场时间">
              <span v-if="formData.vehicleTime === '1'">上午</span>
              <span v-if="formData.vehicleTime === '2'">下午</span>
              <span v-if="formData.vehicleTime === '3'">夜晚</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="goodsCode" label="商品编号">
              {{ formData.goodsCode }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ygRegion" label="收货地址">
              {{ formData.ygRegion }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="ygAddress" label="详情地址">
              {{ formData.ygAddress }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="shippingFee" :label="`运费${formData.inventoryType === '1' ? '单价' : '总价'}`">
              {{ formData.shippingFee }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="isShippingFee" label="是否缴纳运费">
              {{ formData.isShippingFee === '1' ? '是' : '否' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ygNotes" label="备注">
              {{ formData.ygNotes }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :span="24">
          <el-col :span="24">
            <el-form-item label="附件" prop="fileList">
              <div v-if="formData.fileList && formData.fileList.length > 0">
                <div class="" v-for="(item, index) of formData.fileList" :key="index">
                  <a href="javascript:void(0)" @click="onPreview(item)">{{ item.fileName || "-" }}</a>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider content-position="left">审批记录</el-divider>
        <el-row>
          <el-col :span="24">
            <el-timeline>
              <el-timeline-item v-for="(item, index) of formData.recordList" :key="index" :timestamp="item.ctime"
                placement="top">
                <el-card>
                  <h4>审批人：{{ item.nodeName }}</h4>
                  <p>审批结果：{{ nodeResultMap.get(item.nodeResult) }}</p>
                  <p v-if="item.nodeOpinion">审批意见：{{ item.nodeOpinion }}</p>
                </el-card>
              </el-timeline-item>
            </el-timeline>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
    <image-viewer :visible.sync="dialogVisible" :initial-index="currentImageIndex" :url-list="imageList"></image-viewer>
  </div>
</template>

<script>
import { inventoryType, ygType, nodeResult } from '@/utils/dict'
import ImageViewer from '@/components/ImageViewer.vue'
export default {
  name: 'RecordManageDetail',
  components: {
    ImageViewer
  },
  data () {
    return {
      ygTypeMap: ygType,
      inventoryTypeMap: inventoryType,
      nodeResultMap: nodeResult,
      formData: {
        ygId: '', // 油罐id/成品油记录id
        ygType: '',
        ygLevel: '', // 本次变化液位(改)
        ygWeight: '', // 本次变化重量(改)
        userId: '', // 客户id
        driverName: '', // 司机姓名
        driverMobile: '', // 司机手机号
        vehicleKey: '', // 车/船号牌
        vehicleType: '1', // 类型1车辆2船
        vehicleDate: '', // 车/船进厂日期
        vehicleTime: '', // 车/船进厂时间1上午2下午
        inventoryType: '1', // 类型1油罐2成品油
        fileList: [], // 附件列表
        goodsCode: '', // 商品编号 字典goodsCode
        ygRegion: '', // 收货地址-省市区
        ygAddress: '', // 收货地址-详细地址
        shippingFee: '', // 运费单价
        ygNotes: '', // 备注
        nodeOpinion: '', //
        nodeResult: '',
        recordList: [],
        isShippingFee: '0'
      },
      loading: false,
      dialogVisible: false,
      currentImageIndex: 0
    }
  },
  created () {
    if (this.inventoryId) {
      this.loadData()
    }
  },
  computed: {
    inventoryId () {
      return this.$route.query.inventoryId
    },
    formatFileList () {
      return this.formData.fileList.map(file => {
        return {
          name: file.fileName,
          url: file.filePrefix + file.fileUrl
        }
      })
    },
    imageList () {
      return this.formatFileList.filter(item => {
        console.log('item', item)
        return item.name && ['.jpg', '.png', '.jpeg', '.gif'].includes(item.name.substring(item.name.lastIndexOf('.')).toLowerCase())
      })
    }
  },
  methods: {
    onPreview (file) {
      console.log('imageList', this.imageList)
      console.log('file', file)
      console.log(file.fileName.substring(file.fileName.lastIndexOf('.')).toLowerCase())
      if (file.fileName && ['.jpg', '.png', '.jpeg', '.gif'].includes(file.fileName.substring(file.fileName.lastIndexOf('.')).toLowerCase())) {
        this.currentImageIndex = this.imageList.findIndex(url => url.name === file.fileName)
        this.dialogVisible = true
      } else {
        window.open(file.filePrefix + file.fileUrl, '_blank')
      }
    },
    loadData () {
      this.loading = true
      this.$axios.get(this.$apis.recordManage.selectYgInventoryByYgId, {
        params: { inventoryId: this.inventoryId }
      }).then(res => {
        this.formData = res
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.shoufa-form {
  width: 800px;
}

::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-date-editor {
    width: 100%;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
